import {useTranslation} from "ni18n";
import React, {useRef} from "react";
import ReCAPTCHA from "react-google-recaptcha";

import {useTypedSelector} from "../../../store";
import {dev} from "../../_common/_constants";
import {Btn} from "../V5Comp";
import styles from "./CovidReadyForm.module.scss";

const CovidReadyForm = ({handleSubmit, submitting, error}: any) => {
  const i18n = useTranslation();
  const {recaptchaClientKey} = useTypedSelector(({config}) => config);
  const recaptchaRef = useRef(null);

  return (
    <form
      className={styles.form}
      onSubmit={async e => {
        e.preventDefault();
        // @ts-expect-error TS2531: Object is possibly 'null'.
        const captcha = await recaptchaRef.current.executeAsync();
        handleSubmit(e, captcha);
      }}
    >
      {error && (
        <div className="red bold">Something went wrong. Please refresh the page and try again</div>
      )}

      <div className={styles.twoCols}>
        <input
          type="fname"
          className={styles.field}
          required
          placeholder={i18n.t("First name")}
          defaultValue={dev ? "goksel" : ""}
        />
        <input
          type="lname"
          className={styles.field}
          required
          placeholder={i18n.t("Last name")}
          defaultValue={dev ? "eryigit" : ""}
        />
      </div>
      <input
        type="text"
        className={styles.field}
        required
        placeholder={i18n.t("Company name")}
        defaultValue={dev ? "carbon" : ""}
      />
      <input
        type="email"
        className={styles.field}
        required
        placeholder={i18n.t("Work email address")}
        defaultValue={dev ? "goksel@carbonhealth.com" : ""}
      />
      <input
        type="tel"
        className={styles.field}
        placeholder={i18n.t("Phone number")}
        defaultValue={dev ? "000-000-0000" : ""}
      />
      <div className={styles.submitR}>
        <Btn type="submit" fontSize="14px" className="bg-darkGreen">
          {i18n.t("Contact Our Team")}
        </Btn>
        {submitting && <span className={styles.saving}>{i18n.t("saving...")}</span>}
      </div>

      {/* @ts-expect-error TS2769: No overload matches this call */}
      <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaClientKey} size="invisible" />
    </form>
  );
};

export default CovidReadyForm;
